import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { EventBookingProtocol } from './event-booking-protocol.js';
import { EventBookingStrategy } from './event-booking-strategy.js';

export class GenericSellingEventBookingProtocol extends EventBookingProtocol {
  static readonly TYPE_ID: string = '7227144434944b91adc5cb2cb0bc709e';

  public readonly strategy: EventBookingStrategy = EventBookingStrategy.GenericSelling;

  private constructor(
    public readonly deferOrderCompletion: boolean,
    public readonly sendOnlyPaymentConfirmation: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return GenericSellingEventBookingProtocol.TYPE_ID;
  }

  static create(args?: {
    deferOrderCompletion?: boolean,
    sendOnlyPaymentConfirmation?: boolean,
  }): GenericSellingEventBookingProtocol {
    return new GenericSellingEventBookingProtocol(
        args?.deferOrderCompletion ?? false,
        args?.sendOnlyPaymentConfirmation ?? false,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): GenericSellingEventBookingProtocol {
    return new GenericSellingEventBookingProtocol(
        MapUtils.getBoolean(map, 'deferOrderCompletion'),
        MapUtils.getBoolean(map, 'sendOnlyPaymentConfirmation'),
    );
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'strategy': fromEnumAsString(this.strategy),
      'deferOrderCompletion': this.deferOrderCompletion,
      'sendOnlyPaymentConfirmation': this.sendOnlyPaymentConfirmation,
    };
  }

  clone(): this {
    return new GenericSellingEventBookingProtocol(
        this.deferOrderCompletion,
        this.sendOnlyPaymentConfirmation,
    ) as this;
  }

  isSame(other: GenericSellingEventBookingProtocol): boolean {
    if(this === other) {
      return true;
    }

    return other.strategy === this.strategy &&
      other.deferOrderCompletion === this.deferOrderCompletion &&
      other.sendOnlyPaymentConfirmation === this.sendOnlyPaymentConfirmation;
  }

  copyWith(opts?: {
    deferOrderCompletion?: boolean,
    sendOnlyPaymentConfirmation?: boolean,
  }): this {
    return new GenericSellingEventBookingProtocol(
        opts?.deferOrderCompletion ?? this.deferOrderCompletion,
        opts?.sendOnlyPaymentConfirmation ?? this.sendOnlyPaymentConfirmation,
    ) as this;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof GenericSellingEventBookingProtocol;
  }

  static assertType(order: DataModel): order is GenericSellingEventBookingProtocol {
    return order instanceof GenericSellingEventBookingProtocol;
  }
}

export class GenericSellingEventBookingProtocolBuilder extends DataModelBuilder<GenericSellingEventBookingProtocol> {
  build(context: SerializationContext, map: SerializedData): GenericSellingEventBookingProtocol {
    return GenericSellingEventBookingProtocol.fromMap(context, map);
  }
}
